// @flow
import React from 'react';
import TypDokumentApi from './../api/gen/dokumenty/TypDokumentApi';
import StoreSuggestField from "./StoreSuggestField";

/**
 * Field pro hledání typu dokumentů.
 */
class TypDokumentField extends React.Component {

    render() {
        return <StoreSuggestField
            apiCall={() => TypDokumentApi.findTypyDokumentu()}
            inputProps={{placeholder: "Typ dokumentu"}}
            area="shared.typDokumentField"
            getItemId={item => item ? item.kod : null}
            getItemName={item => item ? item.nazev : ""}
            {...this.props}
        />;
    }
}

export default TypDokumentField;
